import React, { useEffect } from 'react';
import Header from '../header';
import { useGetQuery } from '../../api/hooks/useGetQuery';

const Home = () => {
  const { data, exec, isPending, isError, isSuccess }
    = useGetQuery<string>('health_check');

  useEffect(() => {
    exec();
  }, []);
  return (
    <div>
      <Header />
      <p>Self service rounding is up</p>

      <br />
      {isPending && <div>Loading...</div>}
      {isError && <div>An error has occured</div>}
      {isSuccess && (
        <div>
          The backend is:
          {data}
        </div>
      )}
    </div>
  );
};

export default Home;
